import { AccessGate } from '../../shared/access/AccessControls';
import React from 'react';
import MainLayout from '../../shared/components/MainLayout';
import { StyledButtonCard, StyledButtonsWrapper } from './styled';
import { Paths } from '../../router/routes';

const Settings = () => {


  return (
    <MainLayout>
      <StyledButtonsWrapper>
        <AccessGate action="ADMIN_TEXT_LABEL_LIST"><StyledButtonCard to={Paths.controlSettings}>
          <p>Coright Control settings</p>
        </StyledButtonCard></AccessGate>
        <AccessGate action="legacyFilerAdminOnly"><StyledButtonCard to={Paths.contentSettings}>
          <p>Coright Content settings</p>
        </StyledButtonCard></AccessGate>
      </StyledButtonsWrapper>
    </MainLayout>
  );
};

export default Settings;
